import { baseUrl } from './Constants'

const FRONTEND_COMMIT = process.env.REACT_APP_COMMIT || 'unknown'

const badge = (bg) => `background:${bg};color:#fff;padding:2px 6px;border-radius:3px;font-weight:bold`
const mono = 'font-family:monospace;font-weight:bold;color:#160c69'
const muted = 'color:#888'

/**
 * Logs frontend and backend build versions to the browser console so it is
 * easy to confirm which commit is live. Exposes the same data on
 * window.__APP_VERSION__ for quick manual inspection.
 */
export const logVersion = () => {
  window.__APP_VERSION__ = { frontend: FRONTEND_COMMIT, backend: null }
  console.log(`%c FRONTEND %c ${FRONTEND_COMMIT} %c(${process.env.NODE_ENV})`, badge('#b8d23d'), mono, muted)

  fetch(`${baseUrl}/version`, { credentials: 'same-origin' })
    .then(res => (res.ok ? res.json() : Promise.reject(new Error(`HTTP ${res.status}`))))
    .then(backend => {
      window.__APP_VERSION__.backend = backend
      const built = backend.builtAt ? `built ${backend.builtAt}` : ''
      console.log(`%c BACKEND  %c ${backend.shortCommit} %c(${backend.nodeEnv}) ${built} started ${backend.startedAt}`, badge('#160c69'), mono, muted)
      if (backend.shortCommit !== FRONTEND_COMMIT) {
        console.warn(`%c VERSION MISMATCH %c frontend ${FRONTEND_COMMIT} vs backend ${backend.shortCommit}. Try a hard reload (Cmd/Ctrl+Shift+R).`, badge('#d9534f'), '')
      }
    })
    .catch(err => console.warn(`%c BACKEND  %c version unavailable: ${err.message}`, badge('#999'), muted))
}
